// extracted by mini-css-extract-plugin
var _1 = "WVjemS0kq7um056lPDjW";
var _2 = "Brh5A5eTVjmNZK12R6fq";
export { _1 as "details", _2 as "report" }
